
const URL = process.env.REACT_APP_API_ENDPOINT;

export default URL;
